import { ValidatedForm } from 'remix-validated-form';
import { useId, type ReactNode } from 'react';
import { honeyPotSchema } from '~/validations/honeyPotSchema';
import type * as yup from 'yup';
import { withYup } from '@remix-validated-form/with-yup';
import type { FetcherWithComponents } from '@remix-run/react';

export type ValidationBehavior = 'onBlur' | 'onChange' | 'onSubmit';
export type ValidationBehaviorOptions = {
  initial: ValidationBehavior;
  whenTouched: ValidationBehavior;
  whenSubmitted: ValidationBehavior;
};

type TProps = {
  formSchema?: yup.AnyObjectSchema;
  formId?: string;
  actionPath: string;
  method?: 'post' | 'get';
  fetcher?: FetcherWithComponents<unknown>;
  extraClasses?: string;
  onSubmit?: () => void;
  idPrefix?: string;
  children: ReactNode;
};

const ValidatedFormWrapper = ({
  formSchema,
  formId = 'validatedForm',
  actionPath,
  method = 'post',
  fetcher,
  extraClasses = '',
  onSubmit = () => {},
  children,
}: TProps) => {
  const combinedSchema = formSchema ? honeyPotSchema.concat(formSchema) : honeyPotSchema;

  //random id incase form needs to be rendered twice (eg mobile and desktop variant)
  const idPrefix = useId();
  return (
    <>
      <ValidatedForm
        id={formId}
        className={extraClasses}
        validator={withYup(combinedSchema)}
        method={method}
        fetcher={fetcher}
        action={actionPath}
        onSubmit={onSubmit}
      >
        <label
          className="ohnohoney"
          htmlFor={`${idPrefix}-messageHP`}
        ></label>

        <input
          className="ohnohoney"
          autoComplete="off"
          type="text"
          id={`${idPrefix}-messageHP`}
          name={'messageHP'}
          placeholder="Message"
        ></input>
        {children}
      </ValidatedForm>
    </>
  );
};

export default ValidatedFormWrapper;
